export const LOGO = "/vns-logo.png";

export const STATUS_STYLES = {
  Completed: "bg-emerald-100 text-emerald-800 border-emerald-200",
  "In Progress": "bg-amber-100 text-amber-800 border-amber-200",
  Pending: "bg-red-100 text-red-700 border-red-200",
  "On Hold": "bg-slate-100 text-slate-600 border-slate-200",
  Overdue: "bg-red-900 text-white border-red-900",
  Present: "bg-emerald-100 text-emerald-800 border-emerald-200",
  Absent: "bg-red-100 text-red-700 border-red-200",
  "Half Day": "bg-amber-100 text-amber-800 border-amber-200",
  Leave: "bg-slate-100 text-slate-600 border-slate-200",
  High: "bg-red-100 text-red-700 border-red-200",
  Medium: "bg-amber-100 text-amber-800 border-amber-200",
  Low: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export const rowTint = (status, overdue) => {
  if (overdue) return "bg-red-50/60";
  if (status === "Completed") return "bg-emerald-50/40";
  if (status === "In Progress") return "bg-amber-50/40";
  if (status === "Pending") return "bg-red-50/30";
  return "";
};

export const CHART = {
  navy: "#0B2545",
  gold: "#C5A059",
  green: "#10B981",
  amber: "#F59E0B",
  red: "#EF4444",
  darkred: "#991B1B",
  slate: "#94A3B8",
};

export const fmtDate = (d) => {
  try { return new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return d; }
};
